import { render, staticRenderFns } from "./RuntimeEnvironmentWarning.vue?vue&type=template&id=2051008e&"
import script from "./RuntimeEnvironmentWarning.vue?vue&type=script&lang=js&"
export * from "./RuntimeEnvironmentWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports